const state = {
    team: {},
    organisationFilters: {},
    mentionList: [],
    organisations: [],
    organisationRoles: {},
    teamRoles: {},
    isUpdateTeamRoles: false,
    isUpdateOrganisationRoles: false
}
const getters = {
    getTeam (state) {
        return state.team
    },
    getOrganisationFilters (state) {
        return state.organisationFilters
    },
    getMentionList (state) {
        return state.mentionList
    },
    getOrganisations (state) {
        return state.organisations
    },
    getOrganisationRoles (state) {
        return state.organisationRoles
    },
    getTeamRoles (state) {
        return state.teamRoles
    },
    getUpdateOrganisationRoles (state) {
        return state.isUpdateOrganisationRoles
    },
    getUpdateTeamRoles (state) {
        return state.isUpdateTeamRoles
    }
}
const mutations = {
    SET_TEAM (state, payload) {
        state.team = payload
    },
    SET_ORGANISATION_FILTERS (state, payload) {
        state.organisationFilters = payload
    },
    SET_MENTION_LIST(state, payload) {
        state.mentionList = payload
    },
    SET_ORGANSIATIONS (state, payload) {
        state.organisations = payload
    },
    SET_ORGANISATION_ROLES (state, payload) {
        state.organisationRoles = payload
    },
    SET_TEAM_ROLES (state, payload) {
        state.teamRoles = payload
    },
    SET_UPDATE_TEAM_ROLES (state, payload) {
        state.isUpdateTeamRoles = payload
    },
    SET_UPDATE_ORGANISATION_ROLES (state, payload) {
        state.isUpdateOrganisationRoles = payload
    },
    CLEAR_PERMISSIONS_AND_ROLES (state) {
        state.isUpdateTeamRoles = false
        state.teamRoles = {}
        state.organisationRoles = {}
        state.isUpdateOrganisationRoles = false
    }
}
const actions = {
   setTeam ({commit}, payload) {
       commit('SET_TEAM', payload)
   },
   setOganisationFilters ({commit}, payload) {
       commit('SET_ORGANISATION_FILTERS', payload)
   },
   setMentionList ({commit}, payload) {
       commit('SET_MENTION_LIST', payload)
   },
   setOrganisations ({commit}, payload) {
       commit('SET_ORGANSIATIONS', payload)
   },
   setOrganisationRoles ({commit}, payload) {
       commit('SET_ORGANISATION_ROLES', payload)
   },
   setTeamRoles ({commit}, payload) {
       commit('SET_TEAM_ROLES', payload)
   },
   setUpdateTeamRoles ({commit}, payload) {
       commit('SET_UPDATE_TEAM_ROLES', payload)
   },
   setUpdateOrganisationRoles ({commit}, payload) {
       commit('SET_UPDATE_ORGANISATION_ROLES', payload)
   },
   clearPermissionsAndRoles ({commit}) {
       commit('CLEAR_PERMISSIONS_AND_ROLES')
   }
}

export default {
    state,
    mutations,
    actions,
    getters
  }